// Import image files
import AppleCloneImg from './assets/images/AppleCloneImg.webp';
import ChocolateDelightImg from './assets/images/ChocoDelight_Img.webp';
import BtiTexImg from './assets/images/BTI_Tex-Img.webp';
import CodesClueImg from './assets/images/CodesClue_Web.webp';
import MyClassImg from './assets/images/myClass_WebApp.webp';
import TherapixImg from './assets/images/Therapix_Web.webp';
import GreenReleafImg from './assets/images/GreenReleaf_Web.webp';
import ForkLiftImg from './assets/images/ForkLift_App.webp';
import TraderFiImg from './assets/images/TraderFI_Web.webp';
import Trader2BImg from './assets/images/Trader2b_App.webp';
import TanviVideo from './assets/images/TanviVideo.gif';
import TanviImg from './assets/images/TanviIMG.webp';
import KyobeeMarketImg from './assets/images/Kyobee-Market_Web.webp';
import KyobeeWebImg from './assets/images/Kyobee_Web.webp';
import TCLImg from './assets/images/TCL_Web.webp';
import WeareImg from './assets/images/We_Are_Arial_Web.webp';
import HighSchoolImg from './assets/images/Highschool_Babysitter_Web.webp';

import Testimonials from './assets/images/testimonial-svg.svg';

import Theme1 from './assets/images/rosebrown.webp';
import Theme2 from './assets/images/greenlight.webp';
import Theme3 from './assets/images/bluelight.webp';
import Theme4 from './assets/images/redlight.webp';
import Theme5 from './assets/images/orangelight.webp';
import Theme6 from './assets/images/magentalight.webp';
import Theme7 from './assets/images/brownlight.webp';
import Theme8 from './assets/images/greylight.webp';
import Theme9 from './assets/images/yellowlight.webp';
import Theme10 from './assets/images/pinklight.webp';

// Define interfaces for types
interface Link {
  name: string;
  path: string;
}

interface Service {
  id: number;
  name: string;
  title: string;
  description: string;
}

interface Skill {
  id: number;
  name: string;
  percentage: number;
  description: string;
}

interface Project {
  id: number;
  img: string;
  category: string;
  title: string;
  link: string,
  description: string;
  blurhash: string;
}
interface CVItem {
  id: number;
  title: string;
  subtitle: string;
  date: string;
  description: string;
  category: 'education' | 'experience';
}

interface Testimonial {
  id: number;
  img: string;
  name: string;
  author: string;
  description: string;
}

interface Colorswitcher {
  id: number;
  img: string;
  color: string;
}

// Define data using TypeScript
export const links: Link[] = [
  {
    name: 'Home',
    path: 'home',
  },
  {
    name: 'Services',
    path: 'services',
  },
  {
    name: 'Skills',
    path: 'skills',
  },
  {
    name: 'Works',
    path: 'work',
  },
  {
    name: 'Resume',
    path: 'resume',
  },
  {
    name: 'Testimonials',
    path: 'testimonial',
  },
  // {
  //   name: 'Plans',
  //   path: 'plans',
  // },
  {
    name: 'Contact',
    path: 'contact',
  },
];

export const services: Service[] = [
  {
    id: 1,
    name: ' Web Design ',
    title: ' Web Development ',
    description:
      ' Web designers craft the overall vision & plan for a website layout. Professional logo development: Business, Company, or Personal. ',
  },
  {
    id: 2,
    name: ' Poster, Logo & Brochures ',
    title: ' Graphics Designer ',
    description:
      ' Detail-oriented graphics designer known for pushing creative boundaries and delivering aesthetically pleasing designs that resonate with target audiences. ',
  },
  {
    id: 3,
    name: ' Web & App ',
    title: ' UI/UX Designer ',
    description:
      ' Innovative UI/UX designer with a keen eye for detail, transforming complex user requirements into visually appealing and user-friendly design solutions. ',
  },
  {
    id: 4,
    name: ' Animated and Slider video ',
    title: ' Video Editing ',
    description:
      ' Craft visually dynamic and impactful videos through our precise editing, where every frame is curated to convey your message effectively and captivate viewers. ',
  },
  {
    id: 5,
    name: ' React Js Development ',
    title: ' Front End Development ',
    description:
      ' Skilled React.js developer adept at translating design concepts into elegant and efficient user interfaces, ensuring a seamless and engaging web experience. ',
  },
];

export const skills: Skill[] = [
  {
    id: 1,
    name: 'HTML5',
    percentage: 90,
    description:
      ' My skill in HTML extends to crafting web pages with meticulous structure, ensuring not only technical proficiency but also optimal user experience.',
  },

  {
    id: 2,
    name: 'CSS3',
    percentage: 82,
    description:
      'Skilled in crafting visually appealing and responsive user interfaces through CSS, ensuring a seamless and engaging user experience.',
  },

  {
    id: 3,
    name: 'Talwind CSS & Saas CSS',
    percentage: 75,
    description:
      'Experienced in using Tailwind CSS to create responsive and modern user interfaces with utility-first styling, ensuring clean and maintainable code.',
  },

  {
    id: 4,
    name: 'Bootstrap',
    percentage: 80,
    description:
      'Experienced in leveraging Bootstrap to expedite the development process, creating mobile-friendly and responsive designs with ease.',
  },

  {
    id: 5,
    name: 'Javascript',
    percentage: 74,
    description:
      'Proficient in implementing dynamic and interactive features using JavaScript, enhancing user interactivity and overall website functionality.',
  },

  {
    id: 6,
    name: 'React Js',
    percentage: 70,
    description:
      'Adept at building modern, scalable web applications with React.js, utilizing component-based architecture for efficient and maintainable code.',
  },

  {
    id: 7,
    name: 'Adobe Photoshop',
    percentage: 68,
    description:
      'Expertise in utilizing Adobe Photoshop for precise and creative graphic design, ensuring visually stunning and polished website elements.',
  },

  {
    id: 8,
    name: 'Adobe Illustrator',
    percentage: 73,
    description:
      'Skilled in Adobe Illustrator for vector graphics, contributing to the creation of unique and eye-catching illustrations and branding elements.',
  },

  {
    id: 9,
    name: 'Figma',
    percentage: 85,
    description:
      'Proficient in Figma for collaborative design and prototyping, facilitating seamless communication and iteration in the design process.',
  },

  {
    id: 10,
    name: 'GSAP',
    percentage: 70,
    description:
      'My skill in GSAP enables me to create smooth, engaging, and visually appealing animations, bringing websites to life with dynamic motion effects that enhance interactivity and elevate the overall user experience.',
  },
];

export const projects: Project[] = [
  {
    id: 1,
    img: AppleCloneImg,
    category: 'React JS',
    title: 'Apple iPhone 15',
    link: 'https://iphonewebclonebykrushangparmar.netlify.app/',
    description:
      'Super excited to share my latest project! I have built a clone of the Apple iPhone 15 Pro website using React, GSAP, Three.js, and Model Canvas.',
    blurhash: 'UIECU^D$%4xa~W9rInNG=*%LITt8nONYInxa',
  },
  {
    id: 2,
    img: ChocolateDelightImg,
    category: 'React JS',
    title: 'Chococlate Delight',
    link: 'https://chocoberrydelight.netlify.app/',
    description:
      'A modern and visually appealing website showcases chocolate strawberry products with smooth UI, responsive design, and engaging user experience.',
    blurhash: 'UfFPpJ#5_MrqwGNLxBWEyDt2NKbbnNaekBoJ',
  },
  {
    id: 3,
    img: BtiTexImg,
    category: 'HTML5',
    title: 'BTI TEX PVT. LTD.',
    link: 'https://www.btitex.com/',
    description:
      'A textile business, services, and company profile with a clean, structured, and responsive design optimized for all devices.',
    blurhash: 'UKN0*r.R00NYtkxbNFsD009Y~XO9t7nlR%t8',
  },
  {
    id: 4,
    img: CodesClueImg,
    category: 'HTML5',
    title: 'CodesClue Website',
    link: 'https://codescluebykrushang.netlify.app/',
    description:
      'Designed and developed a full-scale, responsive company website consisting of approximately 75-78 pages from scratch for CodesClue.',
    blurhash: 'UIECU^D$%4xa~W9rInNG=*%LITt8nONYInxa',
  },
  {
    id: 5,
    img: TherapixImg,
    category: 'React JS',
    title: 'Therapix',
    link: 'https://app.therapix.ai/login',
    description:
      'I navigate the design  Implemented an AI-powered assistant to enhance user interaction and streamline support.',
    blurhash: 'UIECU^D$%4xa~W9rInNG=*%LITt8nONYInxa',
  },
  {
    id: 6,
    img: MyClassImg,
    category: 'React JS',
    title: 'My Class - Twiin Lab',
    link: 'http://app-dev.myclass-app.com',
    description:
      'I navigate the design realms, sculpting websites with a harmonious blend of HTML, CSS, Bootstrap, and JS in this project in React.',
    blurhash: 'UIECU^D$%4xa~W9rInNG=*%LITt8nONYInxa',
  },
  {
    id: 7,
    img: TCLImg,
    category: 'Shopify',
    title: 'TCL',
    link: 'https://www.thecollegiatelineup.com/',
    description:
      'In this project, I breathe life into digital experiences, crafting captivating websites with HTML and CSS in Shopify.',
    blurhash: 'UxLN73rxxvSitdf8ahah~qS2RQr?xoWEWXbG',
  },
  {
    id: 8,
    img: TraderFiImg,
    category: 'React JS',
    title: 'TraderFi',
    link: 'https://traderfi.trader2b.com/',
    description:
      'I navigate the design realms, sculpting websites with a harmonious blend of HTML, CSS, Bootstrap, and JS in this project in React.',
    blurhash: 'UIECU^D$%4xa~W9rInNG=*%LITt8nONYInxa',
  },
  {
    id: 9,
    img: WeareImg,
    category: 'Wordpress',
    title: 'WE ARE AERIAL',
    link: 'https://www.weareaerial.com/',
    description:
      'I craft web experiences with WordPress plugin themes and CSS as a UI Developer in this project in Wordpress.',
    blurhash: 'UfFPpJ#5_MrqwGNLxBWEyDt2NKbbnNaekBoJ',
  },
  {
    id: 10,
    img: HighSchoolImg,
    category: 'React JS',
    title: 'Highschool Babysitters',
    link: 'https://highschoolbabysitters.com/',
    description:
      'I craft immersive digital realms by sculpting HTML, CSS, Bootstrap, and JS, bringing vibrant life to web experiences in React.',
    blurhash: 'UKN0*r.R00NYtkxbNFsD009Y~XO9t7nlR%t8',
  },
  {
    id: 11,
    img: KyobeeMarketImg,
    category: 'Wordpress',
    title: 'Kyobee - Marketing site',
    link: 'https://www.kyobee.com/',
    description:
    'I craft web experiences with WordPress plugin themes and CSS as a UI Developer in this project in Wordpress.',
    blurhash: 'UKN0*r.R00NYtkxbNFsD009Y~XO9t7nlR%t8',
  },
  {
    id: 12,
    img: KyobeeWebImg,
    category: 'Angular JS',
    title: 'Kyobee',
    link: 'https://production.kyobee.com/',
    description:
      'I design web wonders, harmonizing HTML, CSS, and Bootstrap to bring unique flair to this project in Angular.',
    blurhash: 'UGRxy3yDrWV@xtR5pcVsQ8gOuiniZ$oLtRkW',
  },
  {
    id: 13,
    img: GreenReleafImg,
    category: 'Angular JS',
    title: 'Green Releaf',
    link: 'https://greenreleafdispensary.com/',
    description:
      'I am Implementing a design HTML, CSS, Bootstrap, and JS to breathe life into this project web experiences in Angular.',
    blurhash: 'UIAm3o]}slNy}k=wxDR*^4=Ys.S5=Y-AoMWB',
  },
  {
    id: 14,
    img: Trader2BImg,
    category: 'Native App',
    title: 'Trader2B',
    link: 'https://apps.apple.com/us/app/trader2b/id1593255607',
    description:
      'I craft immersive digital realms, sculpting websites with React Native elegance and CSS flair in this project.',
    blurhash: 'UhIE^ISIxtocXWNGR+WV~ot2R*fiETobSOfk',
  },
  {
    id: 15,
    img: ForkLiftImg,
    category: 'Shopify',
    title: 'Forklift Select',
    link: 'https://forkliftselect.com/?srsltid=AfmBOopWEDqReQYg7EIl3zlYboPh4KpsDIVsvG2RCeMTItYUzRqtcyXB',
    description:
      'In this project, I breathe life into digital experiences, crafting captivating websites with HTML and CSS in Shopify.',
    blurhash: 'U8R1^dgR?cjZ^b006WNz?_xU02NHGJ5B|Bng',
  },
  {
    id: 16,
    img: TanviVideo,
    category: 'Graphics Design',
    title: 'Tanvi`s Chocopedia',
    link: 'https://www.instagram.com/10v_chocopedia/',
    description:
      'Animating festival delights through PowerPoint, whipping up sweet and chocolaty offers in a social media video.',
    blurhash: 'UFQ0N[004Tof~q?bx]NG%3-p%MxuNGIoRkof',
  },
  {
    id: 17,
    img: TanviImg,
    category: 'Graphics Design',
    title: 'Tanvi`s Chocopedia',
    link: 'https://www.instagram.com/10v_chocopedia/',
    description:
      'Illustrating festive vibes through Adobe Illustrator, crafting vibrant social media posters that capture the spirit of celebration.',
    blurhash: 'U8R1^dgR?cjZ^b006WNz?_xU02NHGJ5B|Bng',
  },
];

export const cv: CVItem[] = [
  {
    id: 1,
    title: 'Master`s in Computer Engineering (CSE)',
    subtitle: 'L.D. College of Engineering',
    date: '2022 - 2024',
    description:
      'Achieved a vibrant 8.06 CPI in Master Engineering in CSE, mastering new foundational subjects along the way.',
    category: 'education',
  },

  {
    id: 2,
    title: 'Bachelor`s in Information Technology',
    subtitle: 'Gandhinagar Institute of Technology',
    date: '2019-2022',
    description:
      'Achieved a vibrant 8.58 CPI in Bachelor Engineering in IT, mastering new foundational subjects along the way.',
    category: 'education',
  },

  {
    id: 3,
    title: 'Diploma Engg. in Information Technology',
    subtitle: 'Government Polytechnic. Ahmedabad',
    date: '2015 - 2018',
    description:
      'Achieved a vibrant 8.11 CPI in Diploma Engineering in IT, mastering new foundational subjects along the way.',
    category: 'education',
  },

  {
    id: 4,
    title: 'CodesClue Technologies',
    subtitle: 'UI/UX Designer & Software Developer',
    date: 'Jan 2025 - May 2025',
    description:
      'I designed and transformed UI/UX concepts from Figma into responsive, user-friendly interfaces using HTML, CSS, Bootstrap, JavaScript, React, Angular, and WordPress.',
    category: 'experience',
  },

  {
    id: 5,
    title: 'Ordex Technology Solution Inc',
    subtitle: 'Jr. Software Developer',
    date: 'June 2022 - Nov 2024',
    description:
      'UI Intern Jan-Jun 2022, adept at transforming XD/Figma designs to responsive using HTML, CSS, Bootstrap, and JS with React, Angular, WordPress.',
    category: 'experience',
  },

  {
    id: 6,
    title: 'Jivkorbai Lallubhai High School',
    subtitle: 'Computer Teacher',
    date: 'Dec 2018 - May 2019',
    description:
      'Inspiring as a visitor computer teacher, guiding 9th and 10th-grade students on the exciting journey of computer education.',
    category: 'experience',
  }
];

export const testimonials: Testimonial[] = [
  {
    id: 1,
    img: Testimonials,
    name: 'Burhani Foundation',
    author: 'Founder',
    description:
      'Brother(Krushang) You have perfectly done work. You are good at you work and also completed work before time with very affordable price.',
  },
  {
    id: 2,
    img: Testimonials,
    name: 'Befikre Holidays',
    author: 'Sahil Tripathi',
    description:
      'Krushang your work style so amazing and perfect. You are work with so many efforts and you work in so reasonable price. You work so hard.',
  },
  {
    id: 3,
    img: Testimonials,
    name: 'Sunrise Elevators',
    author: 'Vrajesh Chauhan',
    description:
      'Krushang you work perfectly and your efforts and your work speed so fast. your working streatergy was totally powerful. your comunication skill so amazing.',
  },
  {
    id: 4,
    img: Testimonials,
    name: 'Tevar Tourism',
    author: 'CEO & Founder',
    description:
      'Krushang done his works within time and sometime before time that his plus point and he is very good at his work with economical rate with good quality.',
  },
  {
    id: 5,
    img: Testimonials,
    name: 'Tanvi`s Chocopedia',
    author: 'Tanvi shah',
    description:
      'Krushang done his works with so much Perfection and Dedication at it is best. Thank you so much for giving us best work.',
  },
];

export const theme: Colorswitcher[] = [
  {
    id: 1,
    img: Theme1,
    color: '#BC8F8F',
  },

  {
    id: 2,
    img: Theme2,
    color: '#29A385',
  },

  {
    id: 3,
    img: Theme3,
    color: '#ADD8E6',
  },

  {
    id: 4,
    img: Theme4,
    color: '#FF7F7F',
  },

  {
    id: 5,
    img: Theme5,
    color: '#F89880',
  },

  {
    id: 6,
    img: Theme6,
    color: '#F49AC2',
  },

  {
    id: 7,
    img: Theme7,
    color: '#C19A6B',
  },

  {
    id: 8,
    img: Theme8,
    color: '#ACACAC',
  },

  {
    id: 9,
    img: Theme9,
    color: '#FBD499',
  },

  {
    id: 10,
    img: Theme10,
    color: '#DECCFF',
  },
];
